// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entrance {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
}
.entrance > .entrance-header {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  padding: 8px;
  width: 100%;
}
.entrance > .entrance-header .component-header {
  color: var(--custom-textarea-color);
  pointer-events: none;
  font-size: 18px;
  line-height: 18px;
  margin: 5px 0;
  width: 100%;
  left: 0;
  text-align: center;
}
.entrance > .entrance-header .entrance-header-btns {
  font-size: 18px;
  color: lightgray;
  cursor: pointer;
}
.entrance > .entrance-header .entrance-header-btns:hover {
  color: #e3e3e3 !important;
}
.entrance > .entrance-header .entrance-header-btns i {
  margin-top: 6px;
  margin-right: -5px;
}
.entrance > .entrance-section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: center;
  height: 100%;
  width: 215px;
}
.entrance .component {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: space-around;
  width: 215px;
}
.entrance .component > .component-header {
  color: #005aab;
  font-size: 18px;
  line-height: 18px;
  height: 10%;
}
.entrance .component > .component-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.entrance .component > .component-section::v-deep .non-border-input {
  width: 100%;
}
.login-switch-new-enter-to {
  animation: slide-up-new-in 0.3s forwards;
}
.login-switch-new-enter-active {
  z-index: 10;
  position: absolute;
  background: var(--bgcolor);
  top: 0;
  bottom: 0;
}
.login-switch-new-enter-active:not(.login-switch-new-enter-to) {
  display: none !important;
}
.login-switch-new-leave-to {
  animation: slide-up-new-out 0.3s forwards;
}
.login-switch-back-leave-to {
  animation: slide-dawn-back-out 0.3s forwards;
}
.login-switch-back-enter-active:not(.login-switch-back-enter-to) {
  display: none !important;
}
.login-switch-back-leave-active {
  z-index: 10;
  position: absolute;
  background: var(--bgcolor);
  top: 0;
  bottom: 0;
}
.login-switch-back-enter-to {
  animation: slide-down-new-out 0.3s forwards;
}
@keyframes slide-up-new-in {
0% {
    transform: translateY(100%);
    opacity: 0;
}
100% {
    transform: translateY(0%);
    opacity: 1;
}
}
@keyframes slide-up-new-out {
0% {
    opacity: 1;
}
30% {
    opacity: 0.7;
}
100% {
    opacity: 0;
}
}
@keyframes slide-down-new-out {
0% {
    opacity: 0;
}
100% {
    opacity: 1;
}
}
@keyframes slide-dawn-back-out {
0% {
    transform: translateY(0%);
    opacity: 1;
}
100% {
    transform: translateY(100%);
    opacity: 0;
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/login/Entrance.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,MAAM;EACN,SAAS;AACX;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,MAAM;EACN,SAAS;AACX;AACA;EACE,2CAA2C;AAC7C;AACA;AACA;IACI,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;AACA;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;AACA;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;AACA;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,UAAU;AACd;AACA","sourcesContent":[".entrance {\n  display: flex;\n  flex: 1 1;\n  flex-direction: column;\n  justify-content: center;\n}\n.entrance > .entrance-header {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  padding: 8px;\n  width: 100%;\n}\n.entrance > .entrance-header .component-header {\n  color: var(--custom-textarea-color);\n  pointer-events: none;\n  font-size: 18px;\n  line-height: 18px;\n  margin: 5px 0;\n  width: 100%;\n  left: 0;\n  text-align: center;\n}\n.entrance > .entrance-header .entrance-header-btns {\n  font-size: 18px;\n  color: lightgray;\n  cursor: pointer;\n}\n.entrance > .entrance-header .entrance-header-btns:hover {\n  color: #e3e3e3 !important;\n}\n.entrance > .entrance-header .entrance-header-btns i {\n  margin-top: 6px;\n  margin-right: -5px;\n}\n.entrance > .entrance-section {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  height: 100%;\n  width: 215px;\n}\n.entrance .component {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1;\n  justify-content: space-around;\n  width: 215px;\n}\n.entrance .component > .component-header {\n  color: #005aab;\n  font-size: 18px;\n  line-height: 18px;\n  height: 10%;\n}\n.entrance .component > .component-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.entrance .component > .component-section::v-deep .non-border-input {\n  width: 100%;\n}\n.login-switch-new-enter-to {\n  animation: slide-up-new-in 0.3s forwards;\n}\n.login-switch-new-enter-active {\n  z-index: 10;\n  position: absolute;\n  background: var(--bgcolor);\n  top: 0;\n  bottom: 0;\n}\n.login-switch-new-enter-active:not(.login-switch-new-enter-to) {\n  display: none !important;\n}\n.login-switch-new-leave-to {\n  animation: slide-up-new-out 0.3s forwards;\n}\n.login-switch-back-leave-to {\n  animation: slide-dawn-back-out 0.3s forwards;\n}\n.login-switch-back-enter-active:not(.login-switch-back-enter-to) {\n  display: none !important;\n}\n.login-switch-back-leave-active {\n  z-index: 10;\n  position: absolute;\n  background: var(--bgcolor);\n  top: 0;\n  bottom: 0;\n}\n.login-switch-back-enter-to {\n  animation: slide-down-new-out 0.3s forwards;\n}\n@keyframes slide-up-new-in {\n0% {\n    transform: translateY(100%);\n    opacity: 0;\n}\n100% {\n    transform: translateY(0%);\n    opacity: 1;\n}\n}\n@keyframes slide-up-new-out {\n0% {\n    opacity: 1;\n}\n30% {\n    opacity: 0.7;\n}\n100% {\n    opacity: 0;\n}\n}\n@keyframes slide-down-new-out {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n@keyframes slide-dawn-back-out {\n0% {\n    transform: translateY(0%);\n    opacity: 1;\n}\n100% {\n    transform: translateY(100%);\n    opacity: 0;\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
